import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core'

export const truncateStyles = makeStyles((theme: Theme) => {
  return {
    more: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
  }
})
